// extracted by mini-css-extract-plugin
export var copyableField = "_pd-4";
export var customerBadge = "_pd-0";
export var customerInfoTitle = "_pd-2";
export var details = "_pd-1";
export var dropdownContainer = "_pd-5";
export var dropdownImage = "_pd-6";
export var editAssigneeForm = "_pd-a";
export var editButton = "_pd-3";
export var email = "_pd-7";
export var hidden = "_pd-d";
export var input = "_pd-8";
export var saveButton = "_pd-b";
export var shopifyIcon = "_pd-c";
export var suggestionBadge = "_pd-e";
export var suggestionText = "_pd-f";
export var username = "_pd-9";